import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { TerritoryPanelItem } from '../TerritoryPanelItem';
import { useTerritoryPanel } from '../../context';

interface TerritoryFolderProps {
  repName: string;
  territories: MedScout.Territory[];
  isUserFolder?: boolean;
  onCopy: (territoryId: number) => void;
  onClose?: () => void;
}

const TerritoryFolder: React.FC<TerritoryFolderProps> = ({
  repName,
  territories,
  isUserFolder = false,
  onCopy,
  onClose,
}) => {
  const { expandedReps, selectedTerritory, onToggle, onSelect } =
    useTerritoryPanel();

  return (
    <div className="flex flex-col">
      <button
        onClick={() => onToggle(repName)}
        className="flex items-center gap-4 px-6 py-3 
        hover:bg-neutral-100 hover:text-neutral-800 transition-all duration-300"
        data-testid={`territory-folder-${repName}`}
      >
        <Icon
          size="sm"
          icon={faChevronRight}
          className={`w-4 h-4 transition-transform duration-300 ${
            expandedReps.includes(repName) ? 'rotate-90' : 'rotate-0'
          }`}
        />
        <span className="font-medium text-sm">{repName}</span>
      </button>

      {expandedReps.includes(repName) && (
        <div
          className="px-6 pb-4"
          data-testid={`territory-folder-items-${repName}`}
        >
          {[...territories]
            .sort((a, b) => {
              // For user folder, put canonical territories first
              if (isUserFolder) {
                if (a.is_canonical && !b.is_canonical) return -1;
                if (!a.is_canonical && b.is_canonical) return 1;
              }
              // Then sort alphabetically by name
              return a.name.localeCompare(b.name);
            })
            .map((territory) => (
              <TerritoryPanelItem
                key={territory.id}
                territory={territory}
                isSelected={selectedTerritory?.id === territory.id}
                onSelect={onSelect}
                onCopy={onCopy}
                onClose={onClose ? onClose : undefined}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default TerritoryFolder;
